import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import autoBind from 'auto-bind'
import { withStyles } from '@material-ui/core/styles'
import { Translate, getTranslate } from 'react-localize-redux'

/** Material-UI imports section */
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import RawMaterialNonConfIcon from '@material-ui/icons/BugReport'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { CardHeader, Tooltip, Fab } from '@material-ui/core'
import PersonIcon from '@material-ui/icons/PersonOutline'
import ProcessIcon from '@material-ui/icons/ThumbsUpDownOutlined'
import AceptedIcon from '@material-ui/icons/ThumbUp'
import RejectedIcon from '@material-ui/icons/ThumbDown'
import BugIcon from '@material-ui/icons/BugReport'
import Button from '@material-ui/core/Button'

/** Import component section */
import withauthenticatedLayout from '../layouts/withauthenticatedLayout'
import LoadingPage from '../common/LoadingPage'
import FloatingButton from '../common/FloatingButton'
import DialogAvailableOperations from '../common/DialogAvailableOperations'
import LayoutHeaderWorkFlow from '../common/LayoutHeaderWorkFlow'
import InformationPartial from './components/InformationPartial'
import AddCommonItem from '../common/AddCommonItem'
import Toaster from '../common/Toaster'
import HistoryCard from '../common/HistoryCard'
import Evidence from '../common/Evidence'
import DataTable from '../common/DataTable'
import WorkflowCancel from '../common/WorkflowCancel'
import AddEmergentAction from './../qualityFailureReport/components/AddEmergentAction'
import CreateCorrectiveActionDialog from './../qualityFailureReport/components/CreateCorrectiveActionDialog'
import TrackingPartial from './components/TrackingPartial'

/** Import action section */
import { loadSupplier } from '../../store/suppliers/SupplierActions'
import {
	loadRawMaterialNonConformityFromBackEnd,
	deleteDraftRawMaterial,
	uploadFilesEvidence,
	removeFilesEvidence,
	updateStatusDeviation,
	closedRawMaterialManuallyFromBackend,
	addEmergentActionToRawMaterial,
	removeEmergentActionToRawMaterial,
	addCorrectiveActionsRawMaterial,
	acceptCorrectiveActions,
	updateDataCorrectiveAction,
	registerWarehouseEntryFromBackend,
	udateStatusToWaitingForCompleteTheContainment,
	addAdditionalDocumentRawMaterial,
	removeDocumentActionToRawMaterial,
	acceptDocumentActions,
} from '../../store/rawMaterialNonConformity/RawMaterialActions'
import { getDeliveryOrderByPartNumberCertificate } from '../../store/planning/DeliveryOrdersAction'

import {
	RAW_MATERIAL_NON_CONFORMITY_NOTIFICATION,
	DEVIATION_AUTHORIZATION,
	WORKFLOW_CANCELLATION,
	RAWMATERIAL_CORRECTIVEACTIONS_IMPROVEMENTREQUEST,
} from '../../store/helpers/WorkFlowDocumentsType'
import { converListToArray } from '../../store/helpers/ListHelper'
import { notifyDevolutionMaterialEngineer } from '../../store/rawMaterialNonConformity/RawMaterialActions'
import { IsCurrentActiveDirectoryUser } from '../../store/helpers/SessionHelper'
import { canUserValideModuleQuality } from '../../store/helpers/RolesHelper'
import { COMPANY_PTM } from '../../store/helpers/ResourcesHelper'
import CreateDocumentActionDialog from './components/CreateDocumentActionDialog'

/**
 * Container show RawMaterialNonConformity
 */
class Show extends Component {
	/**
	 * Create an instance RawMaterialNonConformity
	 * @param {*} props
	 */
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			activeTab: 0,
			openAvailableOperationsDialog: false,
			openDeleteDraft: false,
			openModalAddCorrectiveAction: false,
			showActionRequestCommentsDialog: false,
			openModalAddAdditionalDocument: false,
			showDocumentCommentsDialog: false,
		}
	}

	/**
	 * componentDidMount
	 */
	componentDidMount() {
		let rawMaterialToken = this.props.match.params.token
		this.props.loadRawMaterialNonConformity(rawMaterialToken)
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.isLoading !== this.props.isLoading && this.props.rawMaterial !== null) {
			/// Get information full from corrective
			let rawMaterial = this.props.rawMaterial
			this.props.loadSupplier(rawMaterial.supplier_token)
		}
	}

	/**
	 * Action to set state to open of available operations dialog
	 * @memberof
	 */
	setOpenDialog = (openAvailable) => {
		this.setState({
			openAvailableOperationsDialog: openAvailable,
		})
	}

	/**
	 * Function to edit raw material in draft
	 */
	onClickEditRawMaterialNonConformityInDraft() {
		let rawMaterialToken = this.props.match.params.token
		this.props.history.push(`/rawmaterialnonconformity/edit/${rawMaterialToken}`)
	}

	/**
	 * Function to send notification from new raw material
	 */
	onClickSendNotificationRawMaterialNoConformity() {
		let rawMaterialToken = this.props.match.params.token
		this.props.history.push(`/rawmaterialnonconformity/sendNotification/${rawMaterialToken}`)
	}

	/**
	 * Funcction register folio desviation fromraw material
	 */
	onClickRegisterFolioDeviationToRawMaterial() {
		let rawMaterialToken = this.props.match.params.token
		this.props.history.push(`/rawmaterialnonconformity/registerDeviation/${rawMaterialToken}`)
	}

	/**
	 * Function to create devolution from raw mateiral
	 */
	onClickCreateDevolutionToRawMaterial() {
		let rawMaterialToken = this.props.match.params.token
		this.props.history.push(`/rawmaterialnonconformity/createdevolution/${rawMaterialToken}`)
	}

	/**
	 * Function to create rework from raw material
	 */
	onClickCreateReworkToRawMaterial() {
		let rawMaterialToken = this.props.match.params.token
		this.props.history.push(`/rawmaterialnonconformity/createrework/${rawMaterialToken}`)
	}

	/**
	 * Method to change the active tab
	 */
	onClickToActiveTab = (event, value) => {
		this.setState({ activeTab: value })
	}

	/**
	 * onDeleteDraft
	 *
	 * @param {*} item
	 * @param {*} supplier
	 * @memberof Create
	 */
	onDeleteDraft() {
		this.setState({
			openAvailableOperationsDialog: false,
			openDeleteDraft: true,
		})
	}

	onAddCorrectiveActionRequest() {
		console.log('onAddCorrectiveActionRequest')
		this.setState({ correctiveActionItem: null })
		this.handleOpenCloseItemDialog('openModalAddCorrectiveAction')
		this.handleOpenCloseItemDialog('openAvailableOperationsDialog')
	}

	onAddAdditionalDocumentRequest() {
		console.log('onAddAdditionalDocumentRequest')
		this.setState({ additionalDocumentItem: null })
		this.handleOpenCloseItemDialog('openModalAddAdditionalDocument')
		this.handleOpenCloseItemDialog('openAvailableOperationsDialog')
	}

	handleOpenCloseItemDialog(dialogId) {
		this.setState({
			[dialogId]: !this.state[dialogId],
		})
	}

	handleOpenCorrectiveActionDialog(dialogId, item) {
		this.setState(
			{
				correctiveActionItem: item,
			},
			() => this.handleOpenCloseItemDialog(dialogId)
		)
	}

	/**
	 * onDeleteDraftRawMaterial
	 */
	onDeleteDraftRawMaterial() {
		this.props
			.deleteDraftRawMaterial(this.props.rawMaterial.token)
			.then(() => {
				this.setState({
					openDeleteDraft: false,
				})
				this.props.history.push(`/rawmaterialnonconformity`)
			})
			.catch(() => {
				this.setState({
					showToaster: true,
					toasterMessage: <Translate id='common.errorToSave' />,
					toasterVariant: 'error',
				})
			})
	}

	//Cancel a sample request
	onCancelDocument() {
		this.props.history.push(`/rawmaterialnonconformity/cancel/${this.props.rawMaterial.token}`)
	}

	/**
	 * Function to update status deviation
	 * @param {*} tokenRequest
	 * @param {*} comment
	 */
	onUpdateStatusDeviation(tokenDeviation) {
		this.props
			.updateStatusDeviation(tokenDeviation)
			.then(() => {
				this.setState({
					showToView: true,
					showToaster: true,
					toasterVariant: 'success',
					toasterMessage: <Translate id='common.saveCorrectly' />,
				})
			})
			.catch(() => {
				this.setState({
					showToaster: true,
					toasterMessage: <Translate id='common.errorToSave' />,
					toasterVariant: 'error',
				})
			})
	}

	onClickAddEmergentAction() {
		this.setState({
			openAddActionDialog: true,
			openAvailableOperationsDialog: false,
		})
	}

	addEmergentAction(description) {
		this.props.addEmergentAction(description)
		this.setState({ openAddActionDialog: false })
	}

	saveCorrectiveAction(data, isUpdate) {
		if (!isUpdate) {
			return this.props
				.addCorrectiveActions(data)
				.then(() => {
					this.setState({
						showToView: true,
						showToaster: true,
						toasterVariant: 'success',
						toasterMessage: <Translate id='common.saveCorrectly' />,
					})
					return Promise.resolve('Ok')
				})
				.catch(() => {
					this.setState({
						showToaster: true,
						toasterMessage: <Translate id='common.errorToSave' />,
						toasterVariant: 'error',
					})
					return Promise.reject()
				})
		} else {
			return this.props
				.updateDataCorrectiveAction(data)
				.then(() => {
					this.setState({
						showToView: true,
						showToaster: true,
						toasterVariant: 'success',
						toasterMessage: <Translate id='common.saveCorrectly' />,
					})
					return Promise.resolve('Ok')
				})
				.catch(() => {
					this.setState({
						showToaster: true,
						toasterMessage: <Translate id='common.errorToSave' />,
						toasterVariant: 'error',
					})
					return Promise.reject()
				})
		}
	}

	saveAdditionalDocument(data, isUpdate) {
		if (!isUpdate) {
			return this.props
				.addAdditionalDocument(data)
				.then(() => {
					this.setState({
						showToView: true,
						showToaster: true,
						toasterVariant: 'success',
						toasterMessage: <Translate id='common.saveCorrectly' />,
					})
					return Promise.resolve('Ok')
				})
				.catch(() => {
					this.setState({
						showToaster: true,
						toasterMessage: <Translate id='common.errorToSave' />,
						toasterVariant: 'error',
					})
					return Promise.reject()
				})
		}
	}

	handleOpenAdditionalDocumentDialog(dialogId, item) {
		this.setState(
			{
				additionalDocumentItem: item,
			},
			() => this.handleOpenCloseItemDialog(dialogId)
		)
	}

	onAcceptCorrectiveAction(dialogId, item) {
		return this.props
			.acceptCorrectiveActions(item)
			.then(() => {
				this.setState({
					showToaster: true,
					toasterVariant: 'success',
					toasterMessage: <Translate id='common.saveCorrectly' />,
				})
				return Promise.resolve('Ok')
			})
			.catch(() => {
				this.setState({
					showToaster: true,
					toasterMessage: <Translate id='common.errorToSave' />,
					toasterVariant: 'error',
				})
				return Promise.reject()
			})
	}

	onAcceptDocument(dialogId, item) {
		return this.props
			.acceptDocumentActions(item)
			.then(() => {
				this.setState({
					showToaster: true,
					toasterVariant: 'success',
					toasterMessage: <Translate id='common.saveCorrectly' />,
				})
				return Promise.resolve('Ok')
			})
			.catch(() => {
				this.setState({
					showToaster: true,
					toasterMessage: <Translate id='common.errorToSave' />,
					toasterVariant: 'error',
				})
				return Promise.reject()
			})
	}

	onUdateStatusToWaitingForCompleteTheContainment() {
		this.props
			.udateStatusToWaitingForCompleteTheContainment(this.props.rawMaterial.token)
			.then(() => {
				this.setState({
					openAvailableOperationsDialog: false,
					showToView: true,
					showToaster: true,
					toasterVariant: 'success',
					toasterMessage: <Translate id='common.saveCorrectly' />,
				})
			})
			.catch(() => {
				this.setState({
					showToaster: true,
					toasterMessage: <Translate id='common.errorToSave' />,
					toasterVariant: 'error',
				})
			})
	}

	onClickAddRegisterWarehouseEntry() {
		this.setState({
			notExtistFolio: '',
			openAddRegisterSAPDialog: true,
			openAvailableOperationsDialog: false,
		})
	}

	/**
	 * Functions to regiset warehouse entry
	 * @param {*} folio
	 */
	registerWarehouseEntry(folio) {
		this.props
			.registerWarehouseEntry(folio)
			.then((response) => {
				this.setState({
					openAddRegisterSAPDialog: false,
					notExtistFolio: '',
				})
			})
			.catch(() => {
				this.setState({
					notExtistFolio: <Translate id='qualityfailurereport.entryFolioAlready' />,
				})
			})
	}

	/**
	 * Get the card content
	 *
	 * @memberof Show
	 */
	getCardContent() {
		if (this.props.isLoading === true) {
			return <LoadingPage />
		} else if (this.props.rawMaterial !== null) {
			const { classes } = this.props
			return (
				<Grid container spacing={24}>
					<Grid item xs={12}>
						<Divider />
						<AppBar position='static' color='default'>
							<Tabs
								indicatorColor='secondary'
								textColor='secondary'
								className={classes.styleTab}
								value={this.state.activeTab}
								onChange={this.onClickToActiveTab}
							>
								<Tab
									label={
										<p>
											<RawMaterialNonConfIcon />
											{<Translate id='common.information' />}{' '}
										</p>
									}
								/>
								<Tab label={<Translate id='common.evidence' />} />
								{this.props.rawMaterial.quality_events.length !== 0 && (
									<Tab
										label={
											<p>
												<i className='fa fa-eye'></i>{' '}
												<Translate id='qualityfailurereport.tracking' />
											</p>
										}
									/>
								)}
							</Tabs>
						</AppBar>
						{this.state.activeTab === 0 && (
							<InformationPartial
								{...this.props}
								open={this.state.showActionRequestCommentsDialog}
								openModal={this.state.showDocumentCommentsDialog}
								handleOpenCorrectiveActionDialog={this.handleOpenCorrectiveActionDialog}
								onAcceptCorrectiveAction={this.onAcceptCorrectiveAction}
								onAcceptDocument={this.onAcceptDocument}
								handleOpenCloseItemDialog={this.handleOpenCloseItemDialog}
								handleOpenAdditionalDocumentDialog={this.handleOpenAdditionalDocumentDialog}
							/>
						)}
						{this.state.activeTab === 1 && (
							<Evidence
								isDisabled={
									this.props.rawMaterial.is_closed ||
									!IsCurrentActiveDirectoryUser(this.props.currentUser)
								}
								baseApi={process.env.REACT_APP_SIP_QUALITY_URL_FILES}
								removeFiles={this.props.removeFiles}
								uploadFiles={this.props.uploadFiles}
								files={this.props.rawMaterial.attachments}
							/>
						)}
						{this.state.activeTab === 2 && <TrackingPartial {...this.props} />}
					</Grid>
				</Grid>
			)
		}
	}

	/**
	 * Render hystoryCard for Non conformity notification
	 *
	 * @param {*} planningEngineerName
	 * @param {*} developmenEngineerName
	 * @param {*} qualityUsersList
	 * @returns
	 * @memberof Show
	 */
	renderAditionalDataNonConformity(planningEngineerName, developmenEngineerName, qualityUsersList) {
		return (
			<Grid container spacing={24}>
				<CardHeader
					style={{ paddingTop: '0px' }}
					title={
						<Typography gutterBottom variant='body2' component='p'>
							<strong>
								<Translate id='common.sentTo' />:
							</strong>
						</Typography>
					}
					subheader={
						<Typography gutterBottom variant='body2' component='p'>
							<Tooltip title={<Translate id='common.planningEnginner' />}>
								<PersonIcon color='secondary' />
							</Tooltip>
							{' ' + planningEngineerName}
							<br />
							<Tooltip title={<Translate id='common.developmentEnginner' />}>
								<PersonIcon color='secondary' />
							</Tooltip>
							{' ' + developmenEngineerName}
						</Typography>
					}
				/>
				<Grid item xs={12}>
					<DataTable
						title={
							<Typography gutterBottom variant='body2' component='p'>
								<strong>
									{this.props.rawMaterial.company_identifier !== COMPANY_PTM && (
										<Translate id='rawmaterialnonconformity.qualityUsersSupplier' />
									)}
									{this.props.rawMaterial.company_identifier === COMPANY_PTM &&
										'Usuarios de calidad del proveedor y usuarios internos para notificar'}
								</strong>
							</Typography>
						}
						data={qualityUsersList}
						configuration={{
							columns: [
								{
									header: <Translate id='officialNotices.name' />,
									dataSource: 'full_name',
								},
							],
						}}
					/>
				</Grid>
			</Grid>
		)
	}

	/**
	 * Render hystoryCard for Deviations
	 *
	 * @param {*} folio
	 * @param {*} status
	 * @returns
	 * @memberof Show
	 */
	renderAditionalDataDeviation(document) {
		return (
			<Grid container spacing={24}>
				<CardHeader
					style={{ paddingTop: '0px' }}
					title={
						<Typography gutterBottom variant='body2' component='p'>
							<strong>
								<Translate id='rawmaterialnonconformity.deviation' />:
							</strong>
						</Typography>
					}
					subheader={
						<React.Fragment>
							<Typography gutterBottom variant='body2' component='p'>
								<Translate id='common.folio' />:<strong> {' ' + document.folio}</strong>
								<br />
							</Typography>

							{document.status && (
								<p>
									{(document.status === 1 || document.status === 0) && (
										<p>
											<Tooltip title={<Translate id='common.status' />}>
												<ProcessIcon color='primary' />
											</Tooltip>{' '}
											<Translate id='common.statusFolio' />: <Translate id='common.inProcess' />
											<br />
											<br />
											{!this.props.rawMaterial.is_closed && (
												<Button
													variant='contained'
													onClick={() => {
														this.onUpdateStatusDeviation(document.token)
													}}
													disabled={this.props.isSaving}
													color='secondary'
												>
													<ProcessIcon /> {' - '}{' '}
													<Translate id='rawmaterialnonconformity.updateStatusDeviation' />
												</Button>
											)}
										</p>
									)}
									{document.status === 2 && (
										<p>
											<Tooltip title={<Translate id='common.status' />}>
												<AceptedIcon color='secondary' />
											</Tooltip>{' '}
											<Translate id='common.statusFolio' />: <Translate id='common.auhtorized' />
										</p>
									)}
									{document.status === 3 && (
										<p>
											<Tooltip title={<Translate id='common.status' />}>
												<RejectedIcon color='error' />
											</Tooltip>{' '}
											<Translate id='common.statusFolio' />: <Translate id='common.reject' />
										</p>
									)}
								</p>
							)}
						</React.Fragment>
					}
				/>
			</Grid>
		)
	}

	/**
	 * devolution of material
	 */
	onClickDevolutionRawMaterial() {
		this.props
			.notifyDevolutionMaterialEngineer(this.props.rawMaterial.token)
			.then(() => {
				this.setState({
					openAvailableOperationsDialog: false,
					showToView: true,
					showToaster: true,
					toasterVariant: 'success',
					toasterMessage: <Translate id='common.saveCorrectly' />,
				})
			})
			.catch(() => {
				this.setState({
					showToaster: true,
					toasterMessage: <Translate id='common.errorToSave' />,
					toasterVariant: 'error',
				})
			})
	}

	/**
	 * Render hystory section for all documents
	 *
	 * @returns
	 * @memberof Show
	 */
	renderHistory() {
		let documents = this.props.rawMaterial
			? this.props.rawMaterial.documents
				? this.props.rawMaterial.documents
				: []
			: []
		return documents.map((document) => {
			let titleId
			let aditionalData
			if (document.document_type === RAW_MATERIAL_NON_CONFORMITY_NOTIFICATION) {
				titleId = 'menu.rawMaterialsNotification'
				aditionalData = this.renderAditionalDataNonConformity(
					document.planning_engineer_name,
					document.development_engineer_name,
					document.users_quality
				)
			}
			if (document.document_type === RAWMATERIAL_CORRECTIVEACTIONS_IMPROVEMENTREQUEST) {
				titleId = 'common.requestForwardedSupplier'
			}
			if (document.document_type === DEVIATION_AUTHORIZATION) {
				titleId = 'rawmaterialnonconformity.authorizationDeviation'
				aditionalData = this.renderAditionalDataDeviation(document)
			}
			if (document.document_type === WORKFLOW_CANCELLATION) {
				titleId = 'common.folioCancel'
				aditionalData = <WorkflowCancel document={document} />
			}
			return (
				<HistoryCard
					key={document.token}
					title={titleId}
					userCreator={document.create_by}
					creationDate={document.creation_date_long}
					aditionalData={aditionalData}
				/>
			)
		})
	}

	onCloseRawMaterialManually() {
		this.props
			.closedWorkflowManually(this.props.rawMaterial.token)
			.then(() => {
				this.props.loadRawMaterialNonConformity(this.props.rawMaterial.token)
				this.setState({
					showToaster: true,
					toasterVariant: 'success',
					toasterMessage: <Translate id='common.saveCorrectly' />,
				})
			})
			.catch(() => {
				this.setState({
					showToaster: true,
					toasterMessage: <Translate id='common.errorToSave' />,
					toasterVariant: 'error',
				})
			})
	}

	render() {
		let optonsAvalinable = this.props.rawMaterial ? this.props.rawMaterial.get_available_operations : []
		return (
			<Card>
				{optonsAvalinable.length !== 0 && <FloatingButton open={this.setOpenDialog} />}

				<LayoutHeaderWorkFlow
					{...this.props}
					workFlow={this.props.rawMaterial}
					title={<Translate id='rawmaterialnonconformity.titleRawMaterial' />}
				/>

				{this.props.rawMaterial &&
					!this.props.rawMaterial.is_closed &&
					canUserValideModuleQuality(this.props.userRolesByCompany) && (
						<Fab
							variant='extended'
							size='small'
							style={{ marginLeft: 16 }}
							onClick={this.onCloseRawMaterialManually}
							disabled={this.props.isSaving}
						>
							<BugIcon />
							<Typography variant='caption'>
								<Translate id='rawmaterialnonconformity.endReport' />
							</Typography>
						</Fab>
					)}

				<CardContent>{this.getCardContent()}</CardContent>

				{this.renderHistory()}

				<DialogAvailableOperations
					{...this.props}
					isValidToCancel={canUserValideModuleQuality(this.props.userRolesByCompany)}
					options={optonsAvalinable}
					openAvailableOperationsDialog={this.state.openAvailableOperationsDialog}
					setOpenDialog={this.setOpenDialog}
					onClickEditRawMaterialNonConformityInDraft={this.onClickEditRawMaterialNonConformityInDraft}
					onClickToSendNotificationRawMaterial={this.onClickSendNotificationRawMaterialNoConformity}
					onClickRegisterFolioDeviation={this.onClickRegisterFolioDeviationToRawMaterial}
					onClickCreateDevolutionRawMaterial={this.onClickCreateDevolutionToRawMaterial}
					onClickCreateReworkRawMaterial={this.onClickCreateReworkToRawMaterial}
					onDeleteDraft={this.onDeleteDraft}
					onCancelDocument={this.onCancelDocument}
					onClickDevolutionRawMaterial={this.onClickDevolutionRawMaterial}
					onAddEmergentActionInFailure={this.onClickAddEmergentAction}
					onAddCorrectiveActionRequest={this.onAddCorrectiveActionRequest}
					onAddAdditionalDocumentRequest={this.onAddAdditionalDocumentRequest}
					onRegisterWarehouseEntryInFailure={this.onClickAddRegisterWarehouseEntry}
					onUdateStatusToWaitingForCompleteTheContainment={
						this.onUdateStatusToWaitingForCompleteTheContainment
					}
				/>

				{/** Dialog to delete draft */}
				<AddCommonItem
					title={<Translate id='rawmaterialnonconformity.removeRawMaterial' />}
					message={<Translate id='rawmaterialnonconformity.messageToRemove' />}
					open={this.state.openDeleteDraft}
					onClose={() => {
						this.setState({ openDeleteDraft: false })
					}}
					onSaveItem={this.onDeleteDraftRawMaterial}
					isSaving={this.props.isSaving}
					isMessage={true}
				/>

				{this.props.rawMaterial && (
					<AddEmergentAction
						title={
							<span>
								{this.props.rawMaterial.folio}: <Translate id='qualityfailurereport.emergentAction' />
							</span>
						}
						message={<Translate id='qualityfailurereport.descriptionEmergentAction' />}
						open={this.state.openAddActionDialog}
						onClose={() => {
							this.setState({ openAddActionDialog: false })
						}}
						onSaveItem={this.addEmergentAction}
						isSaving={this.props.isSaving}
					/>
				)}

				<CreateCorrectiveActionDialog
					isSaving={this.props.isSaving}
					open={this.state.openModalAddCorrectiveAction}
					folio={this.props.rawMaterial ? this.props.rawMaterial.folio : ''}
					onClose={() => this.handleOpenCloseItemDialog('openModalAddCorrectiveAction')}
					saveCorrectiveAction={this.saveCorrectiveAction}
					classes={this.props.classes}
					item={this.state.correctiveActionItem}
				/>

				<CreateDocumentActionDialog
					isSaving={this.props.isSaving}
					open={this.state.openModalAddAdditionalDocument}
					folio={this.props.rawMaterial ? this.props.rawMaterial.folio : ''}
					onClose={() => this.handleOpenCloseItemDialog('openModalAddAdditionalDocument')}
					saveCorrectiveAction={this.saveAdditionalDocument}
					classes={this.props.classes}
					item={this.state.additionalDocumentItem}
				/>
				{/** Dialog to Add Register Warehouse Entry */}
				<AddCommonItem
					title={<Translate id='qualityfailurereport.registerEntrySap' />}
					message={<Translate id='qualityfailurereport.entryFolioSap' />}
					open={this.state.openAddRegisterSAPDialog}
					onClose={() => {
						this.setState({ openAddRegisterSAPDialog: false })
					}}
					onSaveItem={this.registerWarehouseEntry}
					isSaving={this.props.isSaving}
					notExtistFolio={this.state.notExtistFolio}
					isInput={true}
				/>

				<Toaster
					message={this.state.toasterMessage}
					open={this.state.showToaster}
					variant={this.state.toasterVariant}
					onClose={() => {
						this.setState({ showToaster: false })
					}}
				/>
			</Card>
		)
	}
}

/**
 *  Defines the properties injecteded from the store to view container
 * @param {*} state
 */
function mapStateToProps(state) {
	let rawMaterial = state.rawMaterialNonConformity.get('rawMaterial')
	let selectedCompany = state.profile.get('selectedCompany')
	let user = state.oidc.user ? state.oidc.user : { profile: { name: '', email: '', user_type: '' } }
	let userRolesByCompany = state.profile.get('userRolesByCompany')
	return {
		currentUser: user,
		isLoading: state.rawMaterialNonConformity.get('isLoading'),
		rawMaterial: rawMaterial ? rawMaterial.toJS() : null,
		isSaving: state.rawMaterialNonConformity.get('isSaving'),
		supplier: state.suppliers.get('supplier') ? state.suppliers.get('supplier').toJS() : null,
		company: selectedCompany ? selectedCompany.toJS() : null,
		translate: getTranslate(state.localize),
		userRolesByCompany: userRolesByCompany ? converListToArray(userRolesByCompany) : [],
		isLoadingCertificate: state.deliveryOrders.get('isLoadingCertificate'),
	}
}

/**
 * Defines the actions injectes to the component
 * @param {*} dispatch
 */
const mapDispatchToProps = (dispatch) => {
	return {
		loadRawMaterialNonConformity: (token) => {
			return dispatch(loadRawMaterialNonConformityFromBackEnd(token))
		},
		loadSupplier: (token) => {
			return dispatch(loadSupplier(token))
		},
		uploadFiles: (files) => {
			return dispatch(uploadFilesEvidence(files))
		},
		removeFiles: (fileName) => {
			return dispatch(removeFilesEvidence(fileName))
		},
		deleteDraftRawMaterial: (token) => {
			return dispatch(deleteDraftRawMaterial(token))
		},
		updateStatusDeviation: (tokenDeviation) => {
			return dispatch(updateStatusDeviation(tokenDeviation))
		},
		notifyDevolutionMaterialEngineer: (token) => {
			return dispatch(notifyDevolutionMaterialEngineer(token))
		},
		closedWorkflowManually: (token) => {
			return dispatch(closedRawMaterialManuallyFromBackend(token))
		},
		getDeliveryOrderByPartNumberCertificate: (supplierToken, partNumber, lote) => {
			return dispatch(getDeliveryOrderByPartNumberCertificate(supplierToken, partNumber, lote))
		},
		addEmergentAction: (description) => {
			return dispatch(addEmergentActionToRawMaterial(description))
		},
		removeEmergentAction: (token) => {
			return dispatch(removeEmergentActionToRawMaterial(token))
		},
		addCorrectiveActions: (data) => {
			return dispatch(addCorrectiveActionsRawMaterial(data))
		},
		acceptCorrectiveActions: (item) => {
			return dispatch(acceptCorrectiveActions(item))
		},
		updateDataCorrectiveAction: (data) => {
			return dispatch(updateDataCorrectiveAction(data))
		},
		registerWarehouseEntry: (folio) => {
			return dispatch(registerWarehouseEntryFromBackend(folio))
		},
		udateStatusToWaitingForCompleteTheContainment: (token) => {
			return dispatch(udateStatusToWaitingForCompleteTheContainment(token))
		},
		addAdditionalDocument: (data) => {
			return dispatch(addAdditionalDocumentRawMaterial(data))
		},
		removeDocumentAction: (token) => {
			return dispatch(removeDocumentActionToRawMaterial(token))
		},
		acceptDocumentActions: (item) => {
			return dispatch(acceptDocumentActions(item))
		},
	}
}

const styles = (theme) => ({
	actionsToolbar: {
		flexGrow: 1,
	},
	grow: {
		flexGrow: 1,
	},
	inline: {
		display: 'inline',
	},
	logoCompany: {
		maxHeight: 100,
	},
	logoSupplier: {
		marginLeft: 80,
		maxHeight: 80,
	},
	styleTab: {
		backgroundColor: '#fff',
	},
	margin: {
		margin: theme.spacing.unit * 2,
	},
	container: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '20px',
		borderWidth: 2,
		borderRadius: 2,
		borderColor: '#eeeeee',
		borderStyle: 'dashed',
		backgroundColor: '#fafafa',
		color: '#bdbdbd',
		outline: 'none',
		transition: 'border .24s ease-in-out',
	},
})

export default withauthenticatedLayout(
	withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Show)))
)
